import "./Header.scss";

function Header() {
    return (
        <header>Header</header>
    )
}

export default Header